import { createSelector } from 'reselect'
import shouldShowMinimumToCheckOutBannerCartSelectUtil from 'containers/CartMinimumToCheckOutBanner/selectors/should-show/utils'
import getItemLocalStorageUtil from 'utils/local-storage/get-item'
import { CART_LOCAL_STORAGE_KEY } from 'modules/cart/constants'
import shouldVisuallyShowMinimumToCheckOutCartSelect from 'modules/cart/redux/selectors/should-visually-show-checkout-minimum'
import isSamplesCollectionUrlLocationUtil from 'utils/location/is-samples-collection-url'
import isSampleSubCollectionUrlLocationUtil from 'utils/location/is-sample-sub-collection'
import isSelfGiftingUrlLocationUtil from 'utils/location/is-self-gifting-url'
import isMixedCollectionUrlLocationUtil from 'utils/location/is-mixed-collection-url'

const shouldShowMinimumToCheckOutBannerCartSelect = createSelector(
  shouldVisuallyShowMinimumToCheckOutCartSelect,
  (
    shouldVisuallyShowMinimumToCheckOut
  ) => shouldShowMinimumToCheckOutBannerCartSelectUtil({
    shouldVisuallyShowMinimumToCheckOut,
    closedAtStr: getItemLocalStorageUtil(CART_LOCAL_STORAGE_KEY.CART_MINIMUM_TO_CHECK_OUT_BANNER_CLOSED_AT),
    isFreeSampleCollection: isSamplesCollectionUrlLocationUtil() || isSampleSubCollectionUrlLocationUtil(),
    isSelfGifting: isSelfGiftingUrlLocationUtil(),
    isMixedCollectionUrl: isMixedCollectionUrlLocationUtil()
  })
)

export default shouldShowMinimumToCheckOutBannerCartSelect
